export function bindCharacterCounters() {
    document.querySelectorAll<HTMLElement>("[data-char-limit]").forEach(counter => {
        const target = document.querySelector<HTMLInputElement>(`#${counter?.getAttribute('data-target')}`);
        const ccEvent = target?.getAttribute('char-count-event');

        if (target === null) {
            console.debug('No character counter target defined.');
            return;
        }
        updateCharacterCount(counter, target);

        if (ccEvent === null || ccEvent === undefined || ccEvent !== 'true') {
            target.addEventListener('keyup', evt => {
                target.setAttribute('char-count-event', 'true');
                updateCharacterCount(counter, target);
            });
        }
    });
}

function updateCharacterCount(counter: HTMLElement, target: HTMLInputElement) {
    const targetMaxLength = target.getAttribute('maxlength');
    const counterLimit = counter.getAttribute('data-char-limit');
    const charLimit = (counterLimit === "maxlength") ? Number.parseInt(targetMaxLength || '0') : Number.parseInt(counterLimit || targetMaxLength || '0');
    const charCount = target.value.length;

    counter.classList.add("text-gray-dark");
    if (charCount === 0) {
        counter.innerText = `${charLimit} characters allowed`
    }
    else {
        counter.innerText = `${charLimit - charCount} characters left`;
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    bindCharacterCounters();
});
